export const cargoPackagingTranslationKeys = {
    unspecified: 'intl-msg:ordercom-cloud-frontend.order.packaging-type.unspecified',
    unpackaged: 'intl-msg:ordercom-cloud-frontend.order.packaging-type.unpackaged',
    'euro-pallet': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.euro-pallet',
    'industrial-pallet': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.industrial-pallet',
    'one-way-pallet': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.one-way-pallet',
    'cage-pallet': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.cage-pallet',
    'cardboard-box': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.cardboard-box',
    rack: 'intl-msg:ordercom-cloud-frontend.order.packaging-type.rack',
    'roll-container': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.roll-container',
    'big-bag': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.big-bag',
    ibc: 'intl-msg:ordercom-cloud-frontend.order.packaging-type.ibc',
    coil: 'intl-msg:ordercom-cloud-frontend.order.packaging-type.coil',
    'transport-rack': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.transport-rack',
    trailer: 'intl-msg:ordercom-cloud-frontend.order.packaging-type.trailer',
} as const;

export type CargoPackagingTypes = keyof typeof cargoPackagingTranslationKeys;

export const bulkPackagingTranslationKeys = {
    'bulk-material': 'intl-msg:ordercom-cloud-frontend.order.packaging-type.bulk-material',
} as const;

export type BulkPackagingTypes = keyof typeof bulkPackagingTranslationKeys;
